import PropTypes from 'prop-types';

const AuthHeader = ({ title, description }) => {
  return (
    <div className="auth-header">
      <div className="auth-header-title">{title}</div>
      <div className="auth-header-description">{description}</div>
    </div>
  );
};

export default AuthHeader;

AuthHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
